import { NextImage, noForwardProps } from '@apeiron/temp'
import { ApeironBattleDemoTitle } from '@apeiron/ui'
import { Box, styled } from '@mui/material'

const StyledBannerTitle = styled(ApeironBattleDemoTitle)`
  position: absolute;
  bottom: 100px;
  left: 60px;
  text-transform: uppercase;

  .Custom-Title {
    font-weight: 500;
  }

  ${({ theme }) => theme.breakpoints.down('res768')} {
    left: 20px;
  }
`

const Container = styled(Box)`
  position: relative;
  max-width: 1800px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: center;
`

const BannerImage = styled(NextImage, noForwardProps)<{
  __hasMobileBanner: boolean
}>`
  aspect-ratio: 1800/350;
  height: 350px;

  ${({ theme }) => theme.breakpoints.down('res1024')} {
    ${({ __hasMobileBanner }) => __hasMobileBanner && 'display: none;'}
  }
`

const MobileBannerImage = styled(NextImage)`
  display: none;

  ${({ theme }) => theme.breakpoints.down('res1024')} {
    display: block;
    aspect-ratio: 482/173;
    width: 100vw;
  }
`

type Props = {
  bannerSrc: string
  mobileBannerSrc?: string
  title: string
}

const BannerView = ({ bannerSrc, mobileBannerSrc, title }: Props) => {
  return (
    <Container>
      <Box>
        <BannerImage src={bannerSrc} __hasMobileBanner={!!mobileBannerSrc} />
        {mobileBannerSrc && <MobileBannerImage src={mobileBannerSrc} />}
      </Box>
      <StyledBannerTitle title={title} />
    </Container>
  )
}

export default BannerView
